export default "__VITE_ASSET__233a6052__"